/**
 * The palette a chart falls back to when the account has none.
 *
 * Split out of `apps/frontend/src/hooks/useChartColors.ts` on 2026-09-08
 * (plan one-drawing-layer, A2). The constant is pure; the hook around it is
 * not — it imports `react` and `@/api/preferences` — and the builder's
 * `chartColors` parameter defaults to this list, so a package that may not
 * import from `apps/` needs the constant without the hook. `useChartColors`
 * imports it from here and re-exports it, so its 14 importers are unchanged.
 */
export const DEFAULT_CHART_COLORS = [
  "#5470c6",
  "#91cc75",
  "#fac858",
  "#ee6666",
  "#73c0de",
  "#3ba272",
  "#fc8452",
  "#9a60b4",
  "#ea7ccc",
  "#48b8d0",
];
